import 'rxjs/add/operator/share';
import 'rxjs/add/operator/startWith';

import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

export type Permission = "iam.read" |
  "iam.update" |
  "exams.create" |
  "exams.update" |
  "exams.read" |
  "exam-sessions.schedule-on-behalf" |
  "exam-sessions.bypass.filter.proctoring-capacity" |
  "government-id.read" |
  "government-id.content.read" |
  "government-id.review"

@Injectable()
export class AppGlobals {
  baseURL: BehaviorSubject<string> = new BehaviorSubject<string>('');
  accessToken: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  isUserLoggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  isInvalidToken : boolean = false; // If this value true then we will show Access Denied page else we have to redirect it -> services/externaluser/login

  /**userInfo is used to store current user profile information (authenticate user) */
  userInfo: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  //decide the list of menu to be shown based on the user logged in
  leftMenusList_CUser: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  // used to store logout url based on the user logged in
  logoutURL: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  // used to store the username of the user who failed to log in
  userAttemptingToLogin: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  //looks like no use in application needs to verify
  currentRoute: BehaviorSubject<string> = new BehaviorSubject<string>('');

  //used when site admin change its role to exam scheduler(candidate)
  acType: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  /** We have implemented Guard using this property.
   * If this value will be true then only Child Routes (like AdmManageLocation/:locationId route etc..) will be activated.
   */
  routeWithID: boolean; //used to authenticate route with id
  private selectedUserId = 0;

  /** fixed url to download artifacts(used in exam session) */
  downloadArtifactsUrl: string;
  proctorAccessToken: string;

  /** candidate email is used to send domain of the candidate to backend */
  candidateEmail: string;
  isInternalUser: boolean;

  constructor() {
  }

  /**
   * This property will be used when admin works as Candidate - at that time we have to pass loggedIn userId value in candidate's apis
   * When Candidate will login - then in all apis - userId value will be 0.
   */
  get userId() {
    return this.selectedUserId;

  }

  set userId(value: any) {
    this.selectedUserId = value;
  }

  googleMapAPIKey : string = '';
  selectedExamModel : any = null; // When click on any card then save exam information in this object so that we can use it on other component
  selectedExamLocationModel : any = null; // When click on any Exam location then save that location info here.

  userPermissions: BehaviorSubject<Set<Permission>> = new BehaviorSubject(new Set());
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Common/Services/app.global.ts